const s = {
  name: "Webinar",
  dimensions: { width: 40, height: 36 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 36" style="enable-background:new 0 0 40 36;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M36.3,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.3,1.2-1.3C35.7,3.8,36.3,4.3,36.3,5z"/>
		<path class="st0" d="M20,6c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S22.8,6,20,6z M17,11c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3
			c0,1.7-1.3,3-3,3C18.3,14,17,12.7,17,11z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v24c0,1.7,1.3,3,3,3h12.8l-0.7,4H12v2h16v-2h-3.2l-0.7-4H37c1.7,0,3-1.3,3-3V3
			c0-1.7-1.3-3-3-3H3z M13,28v-5c0-1.7,1.3-3,3-3h8c1.7,0,3,1.3,3,3v5H13z M29,23c0-2.8-2.2-5-5-5h-8c-2.8,0-5,2.2-5,5v5H3
			c-0.5,0-1-0.5-1-1V3c0-0.5,0.5-1,1-1h34c0.5,0,1,0.5,1,1v24c0,0.5-0.5,1-1,1h-8V23z M17.2,34l0.7-4h4.3l0.7,4H17.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Webinar
};
